import { Component, Input, OnInit } from '@angular/core';
import { IRouteRecommendationItinerary } from '../../../../../interfaces/route-recommendations/route-recommendation-itinerary';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { CommonModule } from '@angular/common';
import { CarryoverTagComponent } from '../carryover-tag/carryover-tag.component';
import { EvTagComponent } from '../ev-tag/ev-tag.component';
import { BikeTagComponent } from '../bike-tag/bike-tag.component';
import { ExtenderTagComponent } from '../extender-tag/extender-tag.component';
import { GrabBonusBadgeComponent } from '../../../grab-bonus-badge/grab-bonus-badge.component';

@Component({
  selector: 'route-itinerary-header',
  templateUrl: './route-itinerary-header.component.html',
  styleUrls: [
    './route-itinerary-header.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
  standalone: true,
  imports: [
    VmePipesModule,
    CommonModule,
    CarryoverTagComponent,
    EvTagComponent,
    BikeTagComponent,
    ExtenderTagComponent,
    GrabBonusBadgeComponent,
  ],
})
export class RouteItineraryHeaderComponent implements OnInit {
  isExtension: boolean = false;

  @Input() itinerary: IRouteRecommendationItinerary;

  constructor() {}

  ngOnInit(): void {
    if (this.itinerary && this.itinerary.recommendationTasks) {
      this.isExtension = this.itinerary.recommendationTasks.some((task) => task.grabbed);
    }
  }

  get transportCostDisplay(): string {
    if (!this.itinerary || !this.itinerary.showCosts) {
      return '';
    }

    const minCost = this.itinerary.minTravelCosts || 0;
    const maxCost = this.itinerary.maxTravelCosts || 0;

    if (minCost === 0 && maxCost === 0) {
      return 'No Transport Cost';
    }

    return `£${minCost} - £${maxCost} Est. Transport Cost`;
  }
}
